import { AzureBlobFSWriteSettingsAdapter } from 'app/model/adapters/activities/copysink/store-write-settings/azure-blob-fs-store-write-settings.adapter';
import { storeWriteSettingsAdapts } from 'app/model/adapters/activities/copysink/store-write-settings/store-write-settings.adapter';
import { AdapterRegistry, Metamodel } from 'shell-models-lib';
import { OneLakeFilesWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/one-lake-file-store-write-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OneLakeFilesWriteSettings),
    asynchronous: true,
    adapts: {
        ...storeWriteSettingsAdapts,
        blockSizeInMB: '*',
        metadata: '*'
    }
})
export class OneLakeFileWriteSettingsAdapter extends AzureBlobFSWriteSettingsAdapter {}
